// @flow

import React from 'react';

type Props = {|
  url: ?string,
|};

class ThirdPartyTracking extends React.PureComponent<Props> {
  render() {
    return this.props.url ? (
      <iframe title="Third Party iframe" src={this.props.url} height="0" width="0" hidden />
    ) : null;
  }
}

export default ThirdPartyTracking;
